document.addEventListener('DOMContentLoaded', function() {
    // For the filter form
    const filterForm = document.getElementById('product-filter-form');
    if (filterForm) {
        filterForm.addEventListener('submit', function(e) {
            // Don't add page parameter when submitting form - always go to page 1
            // This is the desired behavior when changing filters
        });
    }
    
    // For the sorting dropdown
    const sortingSelect = document.getElementById('shop-sorting');
    if (sortingSelect) {
        sortingSelect.addEventListener('change', function() {
            const selectedValue = this.value;
            
            // Get current URL and prepare for modification
            let url = new URL(window.location.href);
            
            // Check if we're on a paginated page
            const isPaginated = url.pathname.includes('/page/');
            
            // If paginated and changing sort, go back to page 1 of results
            if (isPaginated) {
                // Extract the base path without pagination
                let basePath = url.pathname.replace(/\/page\/\d+\/?/, '/');
                url.pathname = basePath;
            }
            
            // Remove the orderby parameter if exists
            url.searchParams.delete('orderby');
            
            // Add the orderby parameter if it's not the default "SORT BY" option
            if (selectedValue !== 'default') {
                url.searchParams.set('orderby', selectedValue);
            }
            
            // Redirect to the new URL
            window.location.href = url.toString();
        });
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const perPageSelect = document.getElementById('shop-per-page');
    
    if (perPageSelect) {
        perPageSelect.addEventListener('change', function() {
            const selectedValue = this.value;
            
            // Get current URL and prepare for modification
            let url = new URL(window.location.href);
            
            // Check if we're on a paginated page
            const isPaginated = url.pathname.includes('/page/');
            
            // If paginated and changing per_page, go back to page 1 of results
            if (isPaginated) {
                // Extract the base path without pagination
                let basePath = url.pathname.replace(/\/page\/\d+\/?/, '/');
                url.pathname = basePath;
            }
            
            // Set the per_page parameter
            url.searchParams.set('per_page', selectedValue);
            
            // Redirect to the new URL
            window.location.href = url.toString();
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Combine all initialization into a single function
    function initializeFilters() {
        // Hide filter controls initially - do this IMMEDIATELY to prevent flashing
        const filterControlsElements = document.querySelectorAll('.filter-controls');
        filterControlsElements.forEach((filterControl, index) => {
            filterControl.style.opacity = '0';
            filterControl.style.visibility = 'hidden';
            filterControl.style.transition = 'opacity 0.3s ease-in-out';
        });
        
        // For sorting dropdown
        initializeSelect('shop-sorting');
        
        // For per-page dropdown
        initializeSelect('shop-per-page');
        
        // Function to set up a select element with event handlers
        function initializeSelect(selectId) {
            const select = document.getElementById(selectId);
            if (!select) return;
            
            // First set up the change event handler
            select.addEventListener('change', function() {
                const selectedValue = this.value;
                adjustSelectWidth(this);
                
                // Get current URL and prepare for modification
                let url = new URL(window.location.href);
                
                // Check if we're on a paginated page
                const isPaginated = url.pathname.includes('/page/');
                
                // If paginated and changing filter, go back to page 1 of results
                if (isPaginated) {
                    // Extract the base path without pagination
                    let basePath = url.pathname.replace(/\/page\/\d+\/?/, '/');
                    url.pathname = basePath;
                }
                
                // Handle specific select options
                if (selectId === 'shop-sorting') {
                    url.searchParams.delete('orderby');
                    if (selectedValue !== 'default') {
                        url.searchParams.set('orderby', selectedValue);
                    }
                } else if (selectId === 'shop-per-page') {
                    url.searchParams.set('per_page', selectedValue);
                }
                
                // Redirect to the new URL
                window.location.href = url.toString();
            });
            
            // Set initial width
            setTimeout(function() {
                adjustSelectWidth(select);
                
                // Mark this element as ready
                elementsReady++;
                checkAllReady();
            }, 50);
        }
        
        // Track initialization progress
        let elementsReady = 0;
        let totalElements = document.querySelectorAll('#shop-sorting, #shop-per-page').length;
        
        // Function to check if all elements are ready and show controls
        function checkAllReady() {
            if (elementsReady >= totalElements) {
                filterControlsElements.forEach((filterControl, index) => {
                    filterControl.style.setProperty('visibility', 'visible', 'important');
                    filterControl.style.setProperty('opacity', '1', 'important');
                });
            }
        }
        
        // If no select elements found, still show the controls (failsafe)
        if (totalElements === 0) {
            filterControlsElements.forEach((filterControl, index) => {
                filterControl.style.setProperty('visibility', 'visible', 'important');
                filterControl.style.setProperty('opacity', '1', 'important');
            });
        }

        setTimeout(function() {
            filterControlsElements.forEach((filterControl, index) => {
                filterControl.style.setProperty('visibility', 'visible', 'important');
                filterControl.style.setProperty('opacity', '1', 'important');
            });
        }, 1000);
    }
    
    // Function to adjust the select width based on selected option text
    function adjustSelectWidth(select) {
        // Create a temporary element to measure text width
        const tempElement = document.createElement('span');
        
        // Set up the temp element with the same styling as the select
        const selectStyles = window.getComputedStyle(select);
        tempElement.style.font = selectStyles.font;
        tempElement.style.fontSize = selectStyles.fontSize;
        tempElement.style.fontWeight = selectStyles.fontWeight;
        tempElement.style.textTransform = selectStyles.textTransform;
        tempElement.style.letterSpacing = selectStyles.letterSpacing;
        tempElement.style.whiteSpace = 'nowrap';
        tempElement.style.position = 'absolute';
        tempElement.style.visibility = 'hidden';
        
        // Get the selected option's text
        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return; // Safety check
        
        tempElement.textContent = selectedOption.textContent;
        
        // Add to DOM to calculate width
        document.body.appendChild(tempElement);
        
        // Get the width + extra space for the arrow (24px) + some buffer
        const textWidth = tempElement.offsetWidth;
        const arrowWidth = 24;
        const buffer = 10; // Extra space for padding and to prevent text from being too tight
        
        // Set the select width
        select.style.width = (textWidth + arrowWidth + buffer) + 'px';
        
        // Clean up
        document.body.removeChild(tempElement);
    }
    
    // Start the initialization
    initializeFilters();
});

// Global functions for select onchange handlers
function handleSortingChange(select) {
    adjustSelectWidth(select);
    
    // Determine if we're on a search page
    const urlParams = new URLSearchParams(window.location.search);
    const isSearchPage = urlParams.has('s');
    
    let url = new URL(window.location.href);
    
    if (isSearchPage) {
        // For search pages, maintain search parameters
        const searchTerm = urlParams.get('s') || '';
        url.searchParams.set('s', searchTerm);
        url.searchParams.set('search_type', 'products');
    } else {
        // For shop pages, handle pagination reset
        if (url.pathname.includes('/page/')) {
            url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');
        }
    }
    
    // Handle sorting parameter
    url.searchParams.delete('orderby');
    if (select.value !== 'default') {
        url.searchParams.set('orderby', select.value);
    }
    
    window.location.href = url.toString();
}

function handlePerPageChange(select) {

    adjustSelectWidth(select);
    
    // Determine if we're on a search page
    const urlParams = new URLSearchParams(window.location.search);
    const isSearchPage = urlParams.has('s');
    
    let url = new URL(window.location.href);
    
    if (isSearchPage) {
        // For search pages, maintain search parameters
        const searchTerm = urlParams.get('s') || '';
        url.searchParams.set('s', searchTerm);
        url.searchParams.set('search_type', 'products');
    } else {
        // For shop pages, handle pagination reset
        if (url.pathname.includes('/page/')) {
            url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');
        }
    }
    
    // Set per_page parameter
    url.searchParams.set('per_page', select.value);
    
    window.location.href = url.toString();
}

// Adjust select width based on selected option text
function adjustSelectWidth(select) {
    const tempElement = document.createElement('span');
    const selectStyles = window.getComputedStyle(select);
    
    tempElement.style.font = selectStyles.font;
    tempElement.style.fontSize = selectStyles.fontSize;
    tempElement.style.fontWeight = selectStyles.fontWeight;
    tempElement.style.textTransform = selectStyles.textTransform;
    tempElement.style.letterSpacing = selectStyles.letterSpacing;
    tempElement.style.whiteSpace = 'nowrap';
    tempElement.style.position = 'absolute';
    tempElement.style.visibility = 'hidden';
    
    const selectedOption = select.options[select.selectedIndex];
    if (selectedOption) {
        tempElement.textContent = selectedOption.textContent;
        document.body.appendChild(tempElement);
        
        const textWidth = tempElement.offsetWidth;
        select.style.width = (textWidth + 34) + 'px'; // 24px arrow + 10px buffer
        
        document.body.removeChild(tempElement);
    }
}

// Initialize width adjustment on page load
document.addEventListener('DOMContentLoaded', function() {
    const shopSorting = document.getElementById('shop-sorting');
    const shopPerPage = document.getElementById('shop-per-page');
    
    if (shopSorting) adjustSelectWidth(shopSorting);
    if (shopPerPage) adjustSelectWidth(shopPerPage);
});

// Keep your existing custom search dropdown and other functionality
// (Add the search filter functions here if needed)